import { useQuery } from '@tanstack/react-query';
import { strapiGetWorkOrder } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useWorkOrderDetailQuery(jwt: string | null, documentId: string | null) {
  return useQuery({
    queryKey: queryKeys.workOrderDetail(jwt, documentId),
    queryFn: () => strapiGetWorkOrder(jwt!, documentId!),
    enabled: Boolean(jwt && documentId),
  });
}
